import { Box } from '@chakra-ui/react';
import closeIcon from '@public/assets/icons/control/close.svg';
import Image from 'next/image';

const CloseIcon = ({ onClick }) => (
  <Box
    onClick={onClick}
    cursor="pointer"
    _hover={{ opacity: 0.5 }}
    transition="opacity ease 200ms"
    w={['26px', '26px', '35px', '35px']}
  >
    <Image src={closeIcon} alt="Back Icon" width={35} height={35} />
  </Box>
);

export default CloseIcon;
